import React, { useEffect, useState } from "react";
import i18n from "../../i18n/config";
import { useDispatch, useSelector } from "react-redux";
import { AllocationType, SelectedAllocationType } from "../../types/api/allocations";
import { RootState } from "../../types/redux";
import { ROUTES } from "../../constants/clientRoutes";
import { useHistory } from "react-router-dom";
import { WizardChildProps } from "../../types/props";
import { SetSelectedAllocations } from "../../actions/allocations";

const SelectFreeTransfer = (props: WizardChildProps) => {
  const { setTitle, setForwardButton } = props;
  const { selectedAllocations, feePeriod } = useSelector((state: RootState) => state.allocations);
  const hasShowSelect = selectedAllocations?.some((allocation: AllocationType) => allocation.showSelect);
  const ruleNumberPaid = selectedAllocations?.find((allocation: AllocationType) => allocation.ruleNumberPaid)?.ruleNumberPaid;
  const history = useHistory();
  const dispatch = useDispatch();
  const [freeTransferSelected, setFreeTransferSelected] = useState<number[]>([]);
  const forwardButtonInitialValues = {
    text: i18n.t("COMMON.NEXT"),
    onClick: () => handleForwardClick(),
    disabled: false,
    loading: false
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setTitle(i18n.t("PAGES.ALLOCATIONS.SELECT_FREE_TRANSFER.TITLE"));
    setForwardButton(forwardButtonInitialValues);
  }, []);

  useEffect(() => {
    if (freeTransferSelected.length > ruleNumberPaid) {
      setForwardButton({ ...forwardButtonInitialValues, disabled: true })
    } else {
      setForwardButton({ ...forwardButtonInitialValues, disabled: false })
    }
  }, [freeTransferSelected]);

  const handleForwardClick = () => {
    if (hasShowSelect) {
      const updatedSelectedAllocations = selectedAllocations.map((allocation: SelectedAllocationType) => {
        return ({
          ...allocation,
          selected: freeTransferSelected.includes(allocation.id)
        })
      })

      dispatch(SetSelectedAllocations(updatedSelectedAllocations, feePeriod));
    }

    history.push(ROUTES.ALLOCATIONS.SELECT_ALLOCATION_TYPE);
  }

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, allocationId: number) => {
    if (e.target.checked) {
      setFreeTransferSelected(prev => [...prev, allocationId]);
    } else {
      setFreeTransferSelected(prev => prev.filter(id => id !== allocationId));
    }
  }

  return (
    <>
      <p>{i18n.t("PAGES.ALLOCATIONS.SELECT_FREE_TRANSFER.SUBTITLE_1")} {feePeriod}.</p>
      {hasShowSelect
        ? <p>{i18n.t("PAGES.ALLOCATIONS.SELECT_FREE_TRANSFER.INSTRUCTIONS.USER_CHOICE")}</p>
        : <p>{i18n.t("PAGES.ALLOCATIONS.SELECT_FREE_TRANSFER.INSTRUCTIONS.PRE_SELECTED")}</p>
      }

      {hasShowSelect &&
        <p className="bold text-lg spacing-top-medium">{i18n.t("COMMON.PICK")} {ruleNumberPaid} {i18n.t("PAGES.ALLOCATIONS.SELECT_FREE_TRANSFER.INSTRUCTIONS.USER_CHOICE_COL_HEADING")}</p>
      }

      <section className="overflow-scroll width-100">
        <table className={`table old-navigator-style allocations min-w-500`}>
          <thead>
            <tr>
              {hasShowSelect && <th style={{ width: "10%" }}></th>}
              <th>{i18n.t("PAGES.ALLOCATIONS.INDEX.TABLE.COL_HEADING_1")}</th>
              <th></th>
              <th>{i18n.t("PAGES.ALLOCATIONS.INDEX.TABLE.COL_HEADING_3")}</th>
            </tr>
          </thead>
          <tbody>
            {selectedAllocations.map((allocation: AllocationType) => {
              const toValue = allocation.destinationCountry.name;
              const corridor = `${allocation.destinationCurrency.code} to ${toValue}`;

              if (allocation.cardNumberLastFour) {
                return null;
              }

              return (
                <tr key={allocation.id}>
                  {hasShowSelect &&
                    <td>
                      <div className="checkbox flex-row justify-content-center align-items-center">
                        <input
                          type="checkbox"
                          id={`allocation-${String(allocation.id)}`}
                          onChange={(e) => handleCheckboxChange(e, allocation.id)}
                        />{" "}
                        <label htmlFor={`allocation-${allocation.id}`} aria-label={`check box for ${allocation.accountName}`}>
                        </label>
                      </div>
                    </td>
                  }
                  <td className="flex-col">
                    <p>{allocation.accountName}</p>
                    <p className="italic">{allocation.name}</p>
                  </td>
                  <td>{corridor}</td>
                  {hasShowSelect
                    ? <td>{allocation.feeAmountString}</td>
                    : <td>{allocation.selected ? "Free" : allocation.feeAmountString}</td>
                  }
                </tr>
              )
            })}
          </tbody>
        </table>
      </section>
    </>
  );
}

export default SelectFreeTransfer;